// removed by extract-text-webpack-plugin
module.exports = {"simpleMarker":"c8_c9","selected":"c8_ea","clusterMarker":"c8_eb","simpleMarkerPopup":"c8_ec"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cluster-map/markers/cluster-map.module.scss
// module id = 619
// module chunks = 0